import React from "react";

export const Header = (props) => {
  return (
      <header id="header">
        <div className="intro">
          <div className="overlay">
            <div className="container">

              <div className="row">

                <div className="col-md-8 col-md-offset-2 intro-text">
                  {/* YouTube Embed as the banner */}
                  {/*<div className="video-container">*/}
                  <h1>
                    {props.data ? props.data.title : "Loading"}
                    <span></span>
                  </h1>
                  <br/>
                  <iframe
                      width="100%" // Adjust width as necessary
                      height="400"  // Adjust height as necessary
                      src={`https://www.youtube.com/embed/W57A3xgV5F0?autoplay=1&mute=1&rel=0&loop=1&vq=hd1080&playlist=W57A3xgV5F0`}
                      frameBorder="0"
                      allow="autoplay; encrypted-media; gyroscope; picture-in-picture; web-share;"
                      allowFullScreen
                      title="DMP Supply Introduction"
                  ></iframe>
                  <br/>
                  <br/>
                  {/*</div>*/}
                  {/* Title and paragraph are still available below the video */}

                  <p>{props.data ? props.data.paragraph : "Loading"}</p>
                  <a
                      href="#about"
                      className="btn btn-custom btn-lg page-scroll"
                  >
                    Learn More
                  </a>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
  );
};
